import CancelablePromise from 'mn-utils/CancelablePromise';
import {TCurrency, TFilter, TList, TResponse, TUUID} from '@/types';
import {getDetails, getMetrics, getPayByLinkList, getMinimalAmount} from './mock';
import {apiRequest} from '../../ws';
import {
  TCreateParams,
  TCustomer,
  TDetailsParams,
  TListItem,
  TMetrics,
  TUpdateParams,
} from './types';

import {
  ENDPOINT_MERCHANT_PBL_LIST,
  ENDPOINT_MERCHANT_PBL_DETAILS,
  ENDPOINT_MERCHANT_PBL_CUSTOMERS,
  ENDPOINT_MERCHANT_PBL_CREATE,
  ENDPOINT_MERCHANT_PBL_UPDATE,
  ENDPOINT_MERCHANT_PBL_SEND,
  ENDPOINT_MERCHANT_PBL_REMOVE,
  ENDPOINT_MERCHANT_PBL_LIMITS,
  ENDPOINT_MERCHANT_PBL_CANCEL,
  ENDPOINT_MERCHANT_NEXT_INVOICE_ID
} from '../../../constants/api';

// Получить список инвойсов
export function apiV2PayByLinkList(params: TFilter<TListItem>): Promise<TList<TListItem>> {
  const url = ENDPOINT_MERCHANT_PBL_LIST;
  params = params || {};
  params.offset = params.offset || 0;
  params.limit = params.limit || 50;

  if (process.env.MOCK) {
    const response = {
      list: getPayByLinkList(params.limit),
      count: params.limit * 10,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}

// Получить детальную информацию по инвойсу
export function apiV2PayByLinkDetails(params: TDetailsParams): Promise<TListItem> {
  const url = ENDPOINT_MERCHANT_PBL_DETAILS;

  if (process.env.MOCK) {
    const response = getDetails();
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}

// Получить список кастомеров
export function apiV2PayByLinkCustomers(): Promise<TList<TCustomer>> {
  const url = ENDPOINT_MERCHANT_PBL_CUSTOMERS;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url);
}

// Создать инвойс
export function apiV2PayByLinkCreate(params: TCreateParams): Promise<TUUID> {
  const url = ENDPOINT_MERCHANT_PBL_CREATE;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}

// Обновить инвойс
export function apiV2PayByLinkUpdate(params: TUpdateParams): Promise<TResponse> {
  const url = ENDPOINT_MERCHANT_PBL_UPDATE;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}

// Отправить инвойс
export function apiV2PayByLinkSend(params: {id: TUUID}): Promise<TResponse> {
  const url = ENDPOINT_MERCHANT_PBL_SEND;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}

// Удалить прикрепленный файл
export function apiV2PayByLinkAttachRemove(params: {id: TUUID}): Promise<TResponse> {
  const url = ENDPOINT_MERCHANT_PBL_REMOVE;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, {
    ...params,
    file_id: params.id,
  });
}

export function apiV2PayByLinkGetLimits(params: {fiat_code: TCurrency}): Promise<{amount: string}> {
  const url = ENDPOINT_MERCHANT_PBL_LIMITS;

  if (process.env.MOCK) {
    const response = getMinimalAmount();
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}

export function apiInvoiceGetNextInvoiceNumber() {
  const url = ENDPOINT_MERCHANT_NEXT_INVOICE_ID;
  if (process.env.MOCK) {
    const response = {
      number: 'VASD-0032',
    };
    console.info({url});
    return CancelablePromise.delay(500, response);
  }
  return apiRequest(url);
}

// Отменить инвойс
export function apiV2PayByLinkCancel(params: {id: TUUID}): Promise<TResponse> {
  const url = ENDPOINT_MERCHANT_PBL_CANCEL;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}
